<template>
  <div class="row">
    <div class="col-4">
      <i
        class="fa fa-info-circle fa-fw"
        v-bind:title="'Day Schedule: ' + schedule_info.day_schedule_name"
        aria-hidden="true"></i>
      <b>Next Bell Time: </b> <span v-if="schedule_info.next_bell_time._isValid === true">{{ schedule_info.next_bell_time.format('MMM Do h:mm:ssa') }}</span>
      <span v-else>N/A</span>
      <br>
      <div class="btn-group dropright" v-show="is_authenticated" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
        <button type="button" class="btn btn-sm btn-light dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-stop fa-fw"
              aria-hidden="true"></i> Stop Active
        </button>
        <div class="dropdown-menu">
          <a class="dropdown-item" href="#" @click="stopActiveBells()">
            <i class="fa fa-bell fa-fw"
                aria-hidden="true"></i> Bells
          </a>
          <a class="dropdown-item" href="#" @click="stopActiveAnnouncements()">
            <i class="fa fa-exclamation-circle fa-fw"
                aria-hidden="true"></i> Announcements
          </a>
          <a class="dropdown-item" href="#" @click="stopActiveAlerts()">
            <i class="fa fa-exclamation-circle fa-fw"
                aria-hidden="true"></i> Alerts
          </a>
        </div>
      </div>
      <div class="btn-group dropright" v-show="is_authenticated && filtered_alerts.length > 0" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)">
        <button type="button" class="btn btn-sm btn-light dropdown-toggle" data-toggle="dropdown"
                aria-haspopup="true" aria-expanded="false">
          <i class="fa fa-play fa-fw"
              aria-hidden="true"></i> Execute Alert
        </button>
        <div class="dropdown-menu">
          <a v-for="alert in filtered_alerts"
            :key="alert.alert_id"
            class="dropdown-item"
            href="#"
            @click="executeAlert(alert.alert_id)">
            {{ alert.name }} <span v-if="alert.extension !== 0">({{ alert.extension }})</span>
          </a>
        </div>
      </div>
      <button type="button" class="btn btn-sm btn-light" data-toggle="modal" data-target="#textToSpeechModal" v-show="is_authenticated" v-if="[1,2,3,4,5].includes(logged_in_user.group_id)"><i class="fa fa-keyboard fa-fw" aria-hidden="true"></i> Text-to-Speech</button>
    </div>
    <div class="col-4">
      <b>Current Server Time: </b> <span v-if="current_server_time.hasOwnProperty('_isValid')">{{ current_server_time.format('h:mm:ssa') }}</span>
    </div>
    <div class="col-4" v-if="is_authenticated">
      <b>Logged in as: </b> {{ logged_in_user.username }} ({{ logged_in_user.group.name }})
      <br>
      <b>Site: </b>
      <select class="form-control-sm" v-model="app_scoped_site_id" @change="changeScopedSiteId" v-bind:disabled="disabled_change_scoped_site">
        <option v-for="site in filtered_sites" :key="site.site_id" v-bind:value="site.site_id">
          {{ site.name + ' (' + site.extension_prefix + ')' }}
        </option>
      </select> <br>
      <button class="btn btn-sm btn-light" @click="logout()"><i class="fa fa-sign-out-alt fa-fw"
                                                                    aria-hidden="true"></i> Logout
      </button>
    </div>
    <div class="col-4" v-else>
      <span v-if="site_of_ip"> {{ site_of_ip.name }} </span>
      <br>
      <router-link :to="{ name: 'Login' }" class="btn btn-sm btn-ligh"><i class="fa fa-sign-in-alt fa-fw" aria-hidden="true"></i> Login </router-link>
    </div>
    <div class="modal" id="textToSpeechModal" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Text-to-Speech</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="form-group row">
              <label for="txtMessage" class="col-sm-2 col-form-label">Message</label>
              <div class="col-sm-10">
                <input type="text" maxlength="280" class="form-control" id="txtMessage" v-model="textToSpeechData.message">
                <small class="text-muted">280 characters max</small>
              </div>
            </div>
            <div class="form-group row">
              <label for="ddlVoice" class="col-sm-2 col-form-label">Voice</label>
              <div class="col-sm-10">
                <select class="form-control" id="ddlVoice" v-model="textToSpeechData.voice" disabled>
                  <option value="0">Select..</option>
                  <option value="slt">Sue (Female)</option>
                  <option value="kal">Kal (Male)</option>
                </select>
              </div>
            </div>
            <div class="form-group row">
              <label class="col-sm-2 col-form-label">Zone(s)</label>
              <div class="col-sm-10">
                <v-select multiple v-model="textToSpeechData.zones" :options="zones_for_drop_down"></v-select>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            <button type="button" class="btn btn-hub-primary" @click="executeTts(textToSpeechData)">Send</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'

export default {
  components: { vSelect },
  data: function () {
    return {
      alert_running: false,
      app_scoped_site_id: 1,
      textToSpeechData: {
        message: '',
        voice: 'kal',
        zones: []
      }
    }
  },
  computed: {
    ...mapGetters({
      alerts: 'allAlerts',
      current_server_time: 'currentServerTime',
      disabled_change_scoped_site: 'disabledChangeScopedSite',
      is_authenticated: 'isAuthenticated',
      logged_in_user: 'loggedInUser',
      schedule_info: 'scheduleInfo',
      scoped_site_id: 'scopedSiteId',
      site_of_ip: 'siteOfIp',
      sites: 'allSites',
      zones: 'allZones'
    }),
    filtered_alerts: function () {
      return this.alerts.filter(alert => alert.site_id === this.scoped_site_id)
    },
    filtered_sites: function () {
      return this.sites.filter(site => this.hasSitePermission(site.site_id))
    },
    zones_for_drop_down: function () {
      return this.zones
        .filter(
          zone =>
            zone.site_id === this.scoped_site_id && zone.zone_type_id !== 4
        )
        .map(zone => {
          return {
            value: zone.zone_id,
            label: zone.name
          }
        })
    }
  },
  watch: {
    scoped_site_id (newScopedSiteId, oldScopedSiteId) {
      this.app_scoped_site_id = newScopedSiteId
      this.$store.dispatch('getScheduleInfo')
    }
  },
  created () {
    this.$store.dispatch('getAlerts')
    this.$store.dispatch('getCurrentServerTime')
    this.$store.dispatch('getScheduleInfo')
    this.$store.dispatch('getSites')
    this.$store.dispatch('getZones')
    this.app_scoped_site_id = this.scoped_site_id
  },
  mounted () {
    this.interval = setInterval(this.time, 1000)
    this.interval_schedule_info = setInterval(this.get_schedule_info, 65000)
  },
  methods: {
    ...mapActions(['stopActiveBells', 'stopActiveAnnouncements', 'stopActiveAlerts', 'executeAlert', 'executeTts']),
    changeScopedSiteId () {
      this.$store.dispatch('changeScopedSiteId', this.app_scoped_site_id)
    },
    time () {
      this.$store.dispatch('getCurrentServerTime')
    },
    get_schedule_info () {
      this.$store.dispatch('getScheduleInfo')
    },
    logout () {
      this.password = ''
      this.username = ''
      this.$store.dispatch('logout')
    },
    hasSitePermission (siteId) {
      if ([1, 2].includes(this.logged_in_user.group_id)) {
        if (this.logged_in_user.assigned_site_ids.includes(siteId)) {
          return true
        } else {
          return false
        }
      } else {
        return true
      }
    }
  },
  beforeDestroy () {
    clearInterval(this.interval)
    clearInterval(this.interval_schedule_info)
  }
}
</script>
